import { render, staticRenderFns } from "./TooltipComponent.vue?vue&type=template&id=0c12e42f"
import script from "./TooltipComponent.vue?vue&type=script&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports